import { render, staticRenderFns } from "./LisProjectChild.vue?vue&type=template&id=084839de&scoped=true"
import script from "./LisProjectChild.vue?vue&type=script&lang=js"
export * from "./LisProjectChild.vue?vue&type=script&lang=js"
import style0 from "./LisProjectChild.vue?vue&type=style&index=0&id=084839de&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084839de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('084839de')) {
      api.createRecord('084839de', component.options)
    } else {
      api.reload('084839de', component.options)
    }
    module.hot.accept("./LisProjectChild.vue?vue&type=template&id=084839de&scoped=true", function () {
      api.rerender('084839de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/screeningConfig/lisProject/LisProjectChild.vue"
export default component.exports